import {Component, OnChanges, OnDestroy} from '@angular/core';
import {MenuTitleDescriptionModel} from '../../models/menu-title-description.model';
import {MenuItemModel} from '../../models/menu-item.model';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ItemService} from '../../../provider/item.service';
import {Subscription} from 'rxjs';
import {TranslateModel} from '../../../core/_base/layout/models/translate.model';
import {LanguageTranslatePopup} from '../popup/language-translate/language-translate.popup';
import {MatDialog} from '@angular/material';
import {TranslationService} from '../../../provider/translation.service';

@Component({
  selector: 'c-title-and-description',
  templateUrl: './title-and-description.component.html',
  styleUrls: ['./title-and-description.component.scss']
})
export class TitleAndDescriptionComponent implements OnChanges, OnDestroy {
  ID: number;
  subs: Subscription[] = [];
  titleDesc: MenuTitleDescriptionModel[] = [];
  data: MenuItemModel = new MenuItemModel();
  currentMenuTitleDescriptionModel: MenuTitleDescriptionModel;
  titleDescription: MenuTitleDescriptionModel[] = [];

  constructor(public itemService: ItemService,
              public dialog: MatDialog,
              public tra: TranslationService) {
  }

  ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    let sub = this.itemService.record_change$.subscribe(
      (data: MenuItemModel) => {
        if (!isNotNullOrUndefined(data)) {
          return;
        }
        this.data = data;
      }
    );

    this.subs.push(sub);
    sub = this.itemService.titleDescription_change$.subscribe(
      (datas: MenuTitleDescriptionModel[]) => {
        this.titleDescription = datas;
        if (this.titleDescription.length == 0) {
          this.titleDescription.push(new MenuTitleDescriptionModel());
        }
      }
    );
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuTitleDescription') {
      this.currentMenuTitleDescriptionModel = baseData;
    } else {
      this.currentMenuTitleDescriptionModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.itemService.putItem(this.data);
      if (this.currentMenuTitleDescriptionModel != undefined) {
        this.itemService.putTitleDesData(this.currentMenuTitleDescriptionModel);
      }
    });

  }

// i = index of TitleAndDesc array
  deleteTitleAndDescImg(i: number) {
    this.titleDescription[i].image_url = '';
    this.itemService.deleteFileonAWS(this.titleDescription[i]);
    this.itemService.putTitleDesData(this.titleDescription[i]);
  }

  // i = index of TitleAndDesc array
  deleteTitleAndDesc(i: number) {
    this.itemService.deleteTitleDesData(this.titleDescription[i]);
    this.titleDescription.splice(i, 1);
  }

  addTitleAndDesc() {
    this.itemService.postTitleDesData(new MenuTitleDescriptionModel());
    this.titleDescription.push(new MenuTitleDescriptionModel());
  }

  uploadTitleFile(event: any, item: MenuTitleDescriptionModel, i: number) {
    const selectedFile = event.target.files[0] as File;
    this.itemService.postFile(selectedFile, 'titleDesc', item);
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }
}
